import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Email as EmailIcon } from "@material-ui/icons";
import { Grid, Tooltip, Divider, CircularProgress } from "@material-ui/core";
import translate from "i18n/translate";
import useStyles from "./accountStyles";
import NotificationItem from "./NotificationItem";
import useNotification from "./useNotification";
import { SrAlert, SrButton, Typography } from "../../common";

const mapNotificationSettingsToFromValue = (notificationSettings) =>
  notificationSettings.reduce((accumulator, { name, email: isActive }) => {
    if (typeof name === "string") {
      accumulator[name.toLowerCase()] = isActive;
    }
    return accumulator;
  }, {});

const Notification = () => {
  const classes = useStyles();
  const {
    notificationSettings,
    setNotificationSettings,
    saveNotificationSettings,
    loading,
    error,
  } = useNotification();
  const [initialFormValues, setInitialFormValues] = useState(null);

  useEffect(() => {
    if (notificationSettings.length !== 0) {
      const initialValues =
        mapNotificationSettingsToFromValue(notificationSettings);

      setInitialFormValues(initialValues);
    }
  }, [notificationSettings]);

  const handleDataChange = (name, value) => {
    setNotificationSettings((prevValues) =>
      prevValues.map((prevValue) => {
        const newValue = { ...prevValue };
        if (prevValue.name.toLowerCase() === name) {
          newValue.email = value;
        }
        return newValue;
      })
    );
  };

  return !loading ? (
    <Formik
      initialValues={initialFormValues}
      onSubmit={saveNotificationSettings}
      enableReinitialize
    >
      {({ handleBlur, values, handleSubmit, setFieldValue, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={3}>
            <Grid
              item
              container
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={8} md={5}>
                <Typography variant="h5">
                  {translate("account.notification.notificationVia")}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Tooltip title={translate("common.email")}>
                  <EmailIcon className={classes.emailIcon} />
                </Tooltip>
              </Grid>
            </Grid>
            <Grid item>
              <Divider />
            </Grid>
            {Object.keys(initialFormValues).map((key) => (
              <NotificationItem
                key={key}
                name={key}
                label={translate(`account.notification.${key}`)}
                checked={values[key]}
                onChange={(e) => {
                  setFieldValue(key, e.target.checked);
                  handleDataChange(key, e.target.checked);
                }}
                onBlur={handleBlur}
              />
            ))}
            <Grid item>
              <Divider />
            </Grid>
            {error && (
              <Grid item xs={12}>
                <SrAlert severity="error">{error}</SrAlert>
              </Grid>
            )}
            <Grid container item justifyContent="flex-start">
              <SrButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                {translate("common.saveChanges")}
              </SrButton>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  ) : (
    <div className={classes.loaderWrapper}>
      <CircularProgress />
    </div>
  );
};

export default Notification;
